<div class='min-h-screen flex relative lg:static surface-ground'>
  @if (!isLightRoute) {
  <div id='app-sidebar-1'
       [class.layout-sidebar-collapsed]='isSidebarCollapsed'
       class='surface-section h-screen hidden lg:block flex-shrink-0 absolute lg:sticky left-0 top-0 z-3 border-right-1 surface-border select-none'
       >
    <div class='flex flex-column h-full'>
      <div class='flex align-items-center justify-content-between px-3 flex-shrink-0' style='height: 60px;'>
        <button
          pButton
          type='button'
          [text]='true'
          severity='secondary'
          [icon]="isSidebarCollapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"
          (click)='toggleSidebar()'
          [rounded]='true'
          size='small'
          class='layout-sidebar-toggle'
          aria-label='Toggle sidebar'>
        </button>
      </div>

      <div class='flex flex-column h-full'>
        <ng-container
          [ngTemplateOutlet]='navigationTemplate'
          [ngTemplateOutletContext]="{ isSidebarCollapsed: isSidebarCollapsed }" />
      </div>

      <div class='mt-auto'>
        <hr class='mb-3 mx-3 border-top-1 border-none surface-border'>
        <a pRipple
           class='m-3 flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'>
          <p-avatar
            [label]='getNameInitials(fullName!)'
            class='mr-2'
            [style]="{ width: 'auto', height: 'auto', padding:'5px', 'background-color': '#dee9fc', color: '#1a2551' }" />
          <span
            class='font-medium'>{{ fullName }}</span><span class='p-ink'></span>
        </a>
      </div>
    </div>
  </div>
  }

  <div class='min-h-screen flex flex-column relative flex-auto'
       [class.w-content-expanded]='!isSidebarCollapsed && !isLightRoute'
       [class.w-content-collapsed]='isSidebarCollapsed && !isLightRoute'
       [class.w-content-full]='isLightRoute'>
    <div
      class='flex justify-content-between align-items-center px-5 surface-0 border-bottom-1 surface-border relative lg:static'
      style='height: 60px;'>
      <div class='flex'>
        @if (!isLightRoute) {
          <a pRipple pStyleClass='#app-sidebar-1' enterFromClass='hidden' enterActiveClass='fadeinleft'
             leaveToClass='hidden' leaveActiveClass='fadeoutleft'
             hideOnOutsideClick='true'
             class='cursor-pointer inline-flex align-items-center justify-content-center lg:hidden text-700 mr-3'><i
            class='pi pi-bars text-4xl'></i><span class='p-ink'
                                                  style='height: 45px; width: 45px; top: -9.5px; left: 0.5px;'></span>
          </a>
        }
        <a routerLink='' class='layout-branding flex align-items-center gap-2'>
          <img
            [src]='headerLogoSrc' alt='Partner Platform'
            height='36'>
          <span class='block text-700 text-sm font-medium white-space-nowrap'>{{ systemName }}</span>
        </a>
      </div>
      @if (!isLightRoute) {
        <a pRipple pStyleClass='@next' enterFromClass='hidden' enterActiveClass='fadein' leaveToClass='hidden'
           leaveActiveClass='fadeout' class='p-ripple p-element cursor-pointer block lg:hidden text-700'>
          <i class='pi pi-ellipsis-v text-2xl'></i><span class='p-ink'></span>
        </a>
      }
      <ul
        class='list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-1 shadow-2 lg:shadow-none absolute lg:static'>

        <ng-container [ngTemplateOutlet]='userTemplate' />

        <li class='border-top-1 surface-border lg:border-top-none'>
          <a
            pRipple
            class='p-ripple p-element flex p-3 lg:px-3 lg:py-2 align-items-center justify-content-center hover:surface-100 border-round cursor-pointer transition-duration-150 transition-colors layout-theme-toggle'
            [pTooltip]="(isDarkTheme ? 'switch_to_light_theme' : 'switch_to_dark_theme') | translate"
            tooltipPosition='bottom'
            (click)='toggleTheme()'
          >
            <i [class]="isDarkTheme ? 'pi pi-sun text-lg' : 'pi pi-moon text-lg'"></i>
            <span class='p-ink'></span>
          </a>
        </li>

        <li (click)='userMenuPanel.toggle($event)' class='border-top-1 surface-border lg:border-top-none'>
          <a pRipple
             class='p-ripple p-element flex p-3 lg:px-3 lg:py-2 align-items-center hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors'>
            <p-avatar
              [label]='getNameInitials(fullName!)'
              class='mr-3 lg:mr-0'
              [style]="{ width: 'auto', height: 'auto', padding: '5px', 'background-color': '#dee9fc', color: '#1a2551' }" />

            <p-overlayPanel class='p-0' #userMenuPanel>
              <p-menu [model]='userMenuItems'></p-menu>
            </p-overlayPanel>
            <span class='p-ink'></span>
          </a>
        </li>
      </ul>
    </div>

    @if (goBackToButtonUrl) {
      <div class='card pl-5 pt-4'>
        <a routerLink='/' class='p-button p-button-secondary p-button-outlined font-bold'>
          Back to previous
        </a>
      </div>
    }

    <main class='flex flex-column flex-auto overflow-auto page-content'>
      <div class='border-2 surface-border border-dashed border-round surface-section flex-auto'>
        <router-outlet>
          <p-toast />
        </router-outlet>
      </div>
      <p-scrollTop
        target="parent"
        class="mt-3"
        [threshold]="100"
        buttonAriaLabel="Scroll to top"
        icon="pi pi-arrow-up" />
    </main>
  </div>
</div>
